/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { adDesignUpdate } from '../../axios/adDesignUpdate'
import type {
	AdDesignUpdateError,
	AdDesignUpdatePathParams,
	AdDesignUpdateRequest,
	AdDesignUpdateResponse,
} from '../../types/AdDesignUpdate'

export const adDesignUpdateMutationKey = () => [{ url: '/organisations/:organisation/ad-designs/:adDesign' }] as const

export type AdDesignUpdateMutationKey = ReturnType<typeof adDesignUpdateMutationKey>

export type AdDesignUpdateVariables = {
	organisation: AdDesignUpdatePathParams['organisation']
	adDesign: AdDesignUpdatePathParams['adDesign']
	data: AdDesignUpdateRequest
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/AdDesignController.php AdDesignController::update */
export function useAdDesignUpdate<TContext = unknown>(
	options?: UseMutationOptions<
		AdDesignUpdateResponse,
		AxiosError<AdDesignUpdateError>,
		AdDesignUpdateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: adDesignUpdateMutationKey(),
		mutationFn: ({ organisation, adDesign, data }: AdDesignUpdateVariables) =>
			adDesignUpdate(organisation, adDesign, data, config).then(res => res.data),
		...options,
	})
}
